import { useTenantContext } from "@/contexts/TenantContext"
import type { Tenant } from "@/types/index"

/**
 * Convenience hook that exposes tenant-specific state from TenantContext.
 * Must be used within a TenantProvider.
 *
 * @throws Error if used outside TenantProvider
 */
export function useTenant() {
  const ctx = useTenantContext()
  return {
    tenants: ctx.tenants,
    currentTenant: ctx.currentTenant,
    setCurrentTenant: ctx.setCurrentTenant,
    isDataReady: ctx.isDataReady,
    // isGodMode aliased from isInGodMode
    isGodMode: ctx.isInGodMode,
    godModeTenant: ctx.godModeTenant,
    // enterGodMode with default redirectTo="/funil"
    enterGodMode: (tenant: Tenant) => ctx.enterGodMode(tenant, "/funil"),
    exitGodMode: ctx.exitGodMode,
    hasLoadError: ctx.hasLoadError,
    retryLoad: ctx.retryLoad,
    // Global scope (unit selector)
    selectedScope: ctx.selectedScope,
    setSelectedScope: ctx.setSelectedScope,
    viewAll: ctx.viewAll,
    activeTenantId: ctx.activeTenantId,
    tenantMap: ctx.tenantMap,
    tenantCitiesMap: ctx.tenantCitiesMap,
    activeTenantColor: ctx.activeTenantColor,
  }
}
